const loading = {
  namespaced: true,
  state: {
    loading: false
  },
  getters: {
    isPageLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setPageLoading: function (state, payload = { loading: true }) {
      state.loading = payload.loading
    }
  }
}

export default loading
